import PmParcel from 'interfaces/PmParcel';
import { usePTPConfigContext } from 'GlobalConfig.context';
import { TrackingDetails } from '../../../TrackingDetails';
import { ReturnShipment } from '../../../../models/ReturnShipment.model';

interface FullReturnTrackingDetailsProps {
  shipment: PmParcel;
  hasMultipleShipments: boolean;
}

export const FullReturnTrackingDetails = ({
  shipment: baseShipment,
  hasMultipleShipments,
}: FullReturnTrackingDetailsProps) => {
  const returnShipment = ReturnShipment.create(baseShipment, {
    partial: false,
  });

  const {
    return: { returnFlow },
  } = usePTPConfigContext();
  const isDropOffOptional = returnFlow?.dropOffSelection?.isOptional ?? false;

  const isSelectDropOffSucceed =
    returnShipment.returnTicket.isShipping() &&
    !returnShipment.hasPickupEvents();

  const isReturnRejected = returnShipment.returnTicket.isRejected();

  // isFailedBooking: booking was attempted and failed
  const isFailedBooking = returnShipment.returnTicket.isFailedBooking();
  const isAutoBookingPending =
    returnShipment.returnTicket.isBookingPending() && isDropOffOptional;

  const shouldShowProgressIndicator =
    !isSelectDropOffSucceed &&
    !isFailedBooking &&
    !isAutoBookingPending &&
    !isReturnRejected;

  return (
    <TrackingDetails
      type="full"
      shipment={baseShipment}
      hasMultipleShipments={hasMultipleShipments}
      shouldShowProgressIndicator={shouldShowProgressIndicator}
    />
  );
};
